<template>
  <img class="country-mark" :src="svg" />
</template>
<script>
import CANADA from './country-canada.svg'
import CN from './country-cn.svg'
import GERMANY from './country-de.svg'
import EN from './country-en.svg'
import FRANCE from './country-france.svg'
import HK from './country-hk.svg'
import UK from './country-uk.svg'
import ITALY from './country-ita.svg'
import JAPAN from './country-jp.svg'
import Europe from './country-ou.svg'
import Switzerland from './country-rs.svg'
import US from './country-us.svg'

const pics = {
  CANADA,
  CN,
  GERMANY,
  EN,
  FRANCE,
  HK,
  ITALY,
  JAPAN,
  Europe,
  Switzerland,
  US,
  UK
}

export default {
  name: 'CountryMark',
  props: {
    country: String,
    spin: Boolean
  },
  computed: {
    svg() {
      return pics[this.country]
    }
  }
}
</script>
<style scoped>
.country-mark {
  display: inline-block;
  width: 16px;
  vertical-align: middle;
}
</style>
